import React, { useCallback, useEffect, useMemo, useContext, useRef, useState } from 'react';
import type { NextPage } from 'next';
import styles from './index.module.scss';
import classNames from 'classnames';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CountUp from 'react-countup';
import { Progress } from '@douyinfe/semi-ui';
import Head from 'next/head';
import useRequest from '@/utils/useRequest';
import { getHead, getServerSideProps } from '@/utils/useHead';
import { useDate } from '@/utils/useDate';
import { useRouter } from 'next/router';

interface IProps {

}

export { getServerSideProps }

const Home: NextPage<IProps> = ({ navDetail }: any) => {
  const [activeIndex, setActiveIndex] = useState(1)
  const [isLoad, setIsLoad] = useState(false)
  const [data, setData] = useState<any>({})
  const request = useRequest()
  const router = useRouter()

  const chunkArray = useCallback((arr: any, chunkSize: number) => {
    const chunkedArray = [];
    let index = 0;
    while (index < arr.length) {
      const end = Math.min(index + chunkSize, arr.length);
      chunkedArray.push(arr.slice(index, end));
      index = end;
    }
    return chunkedArray;
  }, [])

  const handleSlideChange = useCallback((swiper: any) => {
    setActiveIndex(swiper.activeIndex + 1)
  }, [])

  const getData = useCallback(async () => {
    const { data } = await request.get(`/home/index`)
    setData(data?.data)
    setIsLoad(true)
  }, [])

  useEffect(() => {
    getData()
  }, [])

  return (
    <div className={styles.container}>
      {getHead(navDetail)}
      <div className={classNames([styles.banner, 'banner'])}>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={0}
          autoplay
          slidesPerView={1}
        >
          {
            data?.banner_list &&
            data?.banner_list.map((item: any) => (
              <SwiperSlide key={item.id}>
                <a href={!!item.url ? item.url : 'javascript:;'} target={!!item.url ? '_blank' : '_self'}>
                  <img style={{ width: '100%' }} loading='lazy' src={item.image} alt="" />
                </a>
              </SwiperSlide>
            ))
          }

        </Swiper>
      </div>
      <div className={styles.bannerBtns}>
        <a className={styles.left} href="https://visitor.organic-festa.com/register" target='_blank'>
          <div>
            <p>观众登记</p>
            <span>即刻预登记，免费参观展会</span>
          </div>
        </a>
        <a className={styles.right} target='_blank' href="https://exhibitor.organic-festa.com/apply">
          <div>
            <div>
              <p>展位申请</p>
              <span>立即进行在线注册，成为展商</span>
            </div>
            <img loading='lazy' src="/image/home-apply-icon.png" alt="" />
          </div>
        </a>
      </div>
      <div className={styles.intro}>
        <div>
          <h1>亚洲<br />有机产业展览会</h1>
          <div>
            <p>该展会致力于汇聚全球有机农业专家、品牌、技术创新者和生态先锋，展示最新有机产品、创新技术与可持续解决方案，倡导有机可持续生活方式，为参展企业创造商业机会，推动亚洲乃至全球有机产业发展，提升市场认知度和接受度，为生产商、分销商和消费者提供深入交流机会，助力有机市场未来发展。</p>
            <a href="/about/overview">了解展会</a>
          </div>
        </div>
      </div>
      <div className={styles.introLink}>
        <a href="https://exhibitor.organic-festa.com/login" target='_blank'>
          <img loading='lazy' src="/image/organic.png" alt="" />
          <p>展商中心</p>
          <span>绿动未来，智领有机，科技赋能产业新生态</span>
        </a>
        <a href="https://visitor.organic-festa.com/login" target='_blank'>
          <img loading='lazy' src="/image/clover.png" alt="" />
          <p>观众中心</p>
          <span>绿动未来，智领有机，科技赋能产业新生态</span>
        </a>
        <a href="/contacts" target='_blank'>
          <img loading='lazy' src="/image/earth.png" alt="" />
          <p>联系我们</p>
          <span>科技引领绿未来，快来加入我们！</span>
        </a>
      </div>
      <div className={styles.survey}>
        <div className={styles.left}>
          <span>—— 展会概览</span>
          <h2>迈向2025有机产业展览会<br />共绘绿色新篇章</h2>
          <p>亚洲有机产业展览会是由国际有机农业亚洲联盟（IFOAM - Organics Asia）与杜塞尔多夫展览（上海）有限公司携手打造的专业平台，将于 2025年9月3 - 5日在上海新国际博览中心举行，以 "有机，可持续未来"为主题，全面覆盖有机全产业链。</p>
          <div>
            <a href="https://online.organic-festa.com/online/exhibitor" className={styles.btn1}>展商&商品</a>
            <a href="" className={styles.btn2}>商贸配对</a>
          </div>
        </div>
        <div className={styles.right}>
          <img loading='lazy' src="/image/home-video-bg.png" alt="" />
        </div>
      </div>
      <ul className={styles.introData}>
        <li>
          <div>
            <p><CountUp
              end={13000}
              duration={1}
              enableScrollSpy
            /><span>+</span></p>
            <span>参观人数</span>
            <div></div>
          </div>
        </li>
        <li>
          <div>
            <p><CountUp
              end={12000}
              duration={1}
              enableScrollSpy
            /><span style={{ fontSize: '36px' }}>㎡</span></p>
            <span>展览面积</span>
            <div></div>
          </div>

        </li>
        <li style={{ flex: '3' }}>
          <div>
            <p><CountUp
              end={300}
              duration={1}
              enableScrollSpy
            /><span>+</span></p>
            <span>海内外专业展商</span>
            <div></div>
          </div>
        </li>
        <li>
          <div>
            <p><CountUp
              end={30}
              duration={1}
              enableScrollSpy
            /><span>+</span></p>
            <span>同期活动</span>
            <div></div>
          </div>
        </li>
      </ul>
      <div className={styles.partner}>
        <span>——合作伙伴</span>
        <h2>合作伙伴，共创有机未来</h2>
        <Swiper
          className={styles.swiper}
          modules={[Autoplay, Pagination]}
          spaceBetween={0}
          autoplay
          pagination={{ clickable: true }}
          slidesPerView={1}
          style={{ paddingBottom: "30px" }}
        >
          {
            data.partner_list &&
            chunkArray(data.partner_list, 6)
              ?.map((item: any) => (
                <SwiperSlide>
                  <div className={styles.brandList}>
                    {
                      item.map((child: any) => (
                        <div className={styles.item}>
                          <a href={child.link_cn ? child.link_cn : "javascript:;"} target={child.link_cn ? '_blank' : '_self'} key={child.id}>
                            <img loading='lazy' src={child.image} alt="" />
                          </a>
                          <p>{child.title_cn}</p>
                        </div>

                      ))
                    }
                  </div>
                </SwiperSlide>
              ))
          }
        </Swiper>
      </div>
      <div className={styles.events}>
        <div>
          <span>——活动及论坛</span>
          <h2>有机未来，共筑绿色梦想
            <p><span>查看更多</span></p>
          </h2>
          <div className={styles.eventList}>
            <div className={styles.left}>
              <div className={styles.top}>
                <img loading='lazy' style={{ opacity: '0' }} src="/image/event-bg1.png" alt="" />
                <div className={classNames([styles.title1])}>
                  {/* <div>
                    <p>远方好物 - 让孩子放心吃的健康安全食品平台</p>
                    <span>——有机生态农业的兴起</span>
                  </div> */}
                </div>
              </div>
              <div className={styles.bottom}>
                <img loading='lazy' src="/image/event-bg2.png" alt="" />
                <div className={classNames([styles.title2, styles.arrow])}>
                  <div>
                    <p>有机绿色食品配套技术与设备及生产</p>
                    <span>——有机生态农业的兴起</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.top}>
                <div className={classNames([styles.title1, styles.arrow])}>
                  <div>
                    <p>农业供需互动话今昔</p>
                    <span>——有机生态农业的兴起</span>
                  </div>
                </div>
              </div>
              <div className={styles.bottom}>
                <img loading='lazy' src="/image/event-bg3.png" alt="" />
                <div className={classNames([styles.title1, styles.arrow])}>
                  <div>
                    <p>有机产品的前景与发展</p>
                    <span>——有机生态农业的兴起</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.comment}>
        <span>——展商评价</span>
        <div>
          <div className={styles.left}>
            <h2>有机产业展览会<br />邀您见证绿色变革！</h2>
            <div>
              <Progress style={{ width: '60%' }} stroke='#0a4020' percent={activeIndex / 3 * 100} />
              <p>
                <span>{activeIndex < 10 ? `0${activeIndex}` : activeIndex}</span>
                <span style={{ margin: '0 5px' }}>/</span>
                <span style={{ color: '#aaa' }}>03</span>
              </p>
            </div>

          </div>
          <div className={styles.right}>
            <Swiper
              modules={[Autoplay]}
              spaceBetween={0}
              autoplay
              slidesPerView={1}
              style={{ height: 'auto' }}
              onSlideChange={(swiper: any) => handleSlideChange(swiper)}
            >
              <SwiperSlide>
                <p>杜塞尔多夫展览（上海）有限公司将利用其丰富的展会组织经验及亚洲中心的市场布局，与国际有机农业亚洲联盟 (IFOAM-Organics Asia)的专业知识和行业影响力相结合，共同为有机产业提供一个高标准的展示和交流平台。这不仅有助于提升有机产品的市场认知度和接受度，也将为参展企业提供更多的商业机会和市场拓展可能性。</p>
                <div className={styles.commentBottom}>
                  <div>
                    <div className={styles.logo}>
                      <img loading='lazy' src="/image/logo1.png" alt="" />
                    </div>
                    <p>杜塞尔多夫展览<span>顾燕 总经理</span></p>
                  </div>
                  <img loading='lazy' src="/image/home-comment-icon.png" alt="" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <p>杜塞尔多夫展览（上海）有限公司将利用其丰富的展会组织经验及亚洲中心的市场布局，与国际有机农业亚洲联盟 (IFOAM-Organics Asia)的专业知识和行业影响力相结合，共同为有机产业提供一个高标准的展示和交流平台。这不仅有助于提升有机产品的市场认知度和接受度，也将为参展企业提供更多的商业机会和市场拓展可能性。</p>
                <div className={styles.commentBottom}>
                  <div>
                    <div className={styles.logo}>
                      <img loading='lazy' src="/image/logo1.png" alt="" />
                    </div>
                    <p>杜塞尔多夫展览<span>顾燕 总经理</span></p>
                  </div>
                  <img loading='lazy' src="/image/home-comment-icon.png" alt="" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <p>杜塞尔多夫展览（上海）有限公司将利用其丰富的展会组织经验及亚洲中心的市场布局，与国际有机农业亚洲联盟 (IFOAM-Organics Asia)的专业知识和行业影响力相结合，共同为有机产业提供一个高标准的展示和交流平台。这不仅有助于提升有机产品的市场认知度和接受度，也将为参展企业提供更多的商业机会和市场拓展可能性。</p>
                <div className={styles.commentBottom}>
                  <div>
                    <div className={styles.logo}>
                      <img loading='lazy' src="/image/logo1.png" alt="" />
                    </div>
                    <p>杜塞尔多夫展览<span>顾燕 总经理</span></p>
                  </div>
                  <img loading='lazy' src="/image/home-comment-icon.png" alt="" />
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>

      </div>
      <div className={styles.photos}>
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/93a499967e55b8f819cab82d3d222b9b.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/09517ae2bfc50de5aebfefbb2f09be65.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/a2d443b0b8754b03cf43627418123c95.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/87bdbaf43b5f27d325573c4749b97047.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/e34ba805b39cac3938456d278e52cbbc.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/701f29beb8ac0aa6bbc9c1607381d296.jpg" alt="" />
      </div>
      <div className={styles.news}>
        <div>
          <span>——新闻动态</span>
          <h2>了解展会新资讯
            <p onClick={() => router.push('/media/show')}><span>查看更多</span></p>
          </h2>
          <Swiper
            modules={[Autoplay]}
            autoplay
            breakpoints={
              {
                0: {
                  slidesPerView: 1,
                },
                888: {
                  slidesPerView: 3,
                },
              }
            }
            loop
            spaceBetween={30}
            style={{ height: '369px' }}
          >
            {
              data?.news_list &&
              data.news_list.map((item: any) => (
                <SwiperSlide key={item.id}>
                  <div className={styles.item}>
                    <a href={item.url ? item.url : `/media/news_detail/${item.id}`} target='_blank'>
                      <div className={styles.top}>
                        <div>
                          <span>
                            {
                              item.publish_time ?
                                Object.values(useDate(item.publish_time))
                                  .join('.')
                                : ''
                            }
                          </span>
                          <div className={styles.tag}>{item.category.name_cn}</div>
                        </div>
                        <p>{item.title_cn}</p>
                      </div>
                      <div className={styles.bottom}>
                        <img loading='lazy' src={item.image} alt="" />
                      </div>
                    </a>
                  </div>
                </SwiperSlide>

              ))
            }
          </Swiper>
        </div>
      </div>
      <div className={styles.exhibitor}>
        <div className={styles.title}>
          <span>——推荐展商</span>
          <h2>有机产业风起云涌<br />绿色发展引领潮流
            <p><span>查看更多</span></p>
          </h2>
        </div>
        <Swiper
          className={styles.logoSwiper}
          modules={[Autoplay]}
          spaceBetween={30}
          autoplay
          loop
          breakpoints={
            {
              0: {
                slidesPerView: 3,
              },
              888: {
                slidesPerView: 5,
              },
            }
          }
          style={{ height: 'auto' }}
        >
          {
            data?.recommended_exhibitor_list &&
            data.recommended_exhibitor_list
              .slice(0, Math.ceil(data.recommended_exhibitor_list.length / 2))
              .map((item: any) => (
                <SwiperSlide key={item.id}>
                  <a href={item.url ? item.url : "javascript:;"} target={item.url ? '_blank' : '_self'}>
                    <div className={styles.logoBox}>
                      <img loading='lazy' src={item.image} alt="" />
                    </div>
                  </a>
                </SwiperSlide>
              ))
          }
        </Swiper>
        <Swiper
          className={styles.swiper2}
          modules={[Autoplay]}
          breakpoints={
            {
              0: {
                slidesPerView: 3,
              },
              888: {
                slidesPerView: 5,
              },
            }
          }
          autoplay
          loop
          style={{ height: 'auto' }}
        >
          {
            data?.recommended_exhibitor_list &&
            data.recommended_exhibitor_list
              .slice(Math.ceil(data.recommended_exhibitor_list.length / 2))
              .map((item: any) => (
                <SwiperSlide key={item.id}>
                  <a style={{ marginRight: '30px', display: 'block' }} href={item.url ? item.url : "javascript:;"} target={item.url ? '_blank' : '_self'}>
                    <div className={styles.logoBox}>
                      <img loading='lazy' src={item.image} alt="" />
                    </div>
                  </a>
                </SwiperSlide>
              ))
          }
        </Swiper>
      </div>
      <style global jsx>
        {
          `
          .swiper-pagination-bullet{
            width: 40px;
            height: 6px;
            border-radius: 2px;
            background-color: #e3e3e3;
          }
          .swiper-pagination-bullet{
            background-color: #393637;
          }
          .swiper-pagination-bullet-active{
            background-color:#93d40b !important;
          }
          `
        }
      </style>
    </div>
  );
};

export default Home;
